import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';
import { appendUTM } from '../utils/utm';

function LandingPage() {
  const navigate = useNavigate();
  const { language, setLanguage, t } = useLanguage();

  return (
    <div className="container">
      <div className="header">
        <div className="logo-section">
          <img src="/misk_logo.png" alt="MISK Logo" style={{width: '80px', height: '80px'}} />
          <div>
            <h1>MISK Learning Center</h1>
            <p className="subtitle">{t('subtitle')}</p>
          </div>
        </div>
        <div style={{textAlign: 'right'}}>
          <select value={language} onChange={(e) => setLanguage(e.target.value)} className="lang-select">
            <option value="en">English</option>
            <option value="ta">தமிழ்</option>
            <option value="ar">العربية</option>
          </select>
          <div style={{marginTop: '8px'}}>
            <a href={appendUTM('/login')} style={{fontSize: '0.85rem', color: '#1a6b35', textDecoration: 'none'}}>
              {t('staffLogin')}
            </a>
          </div>
        </div>
      </div>

      <div className="card" style={{textAlign: 'center'}}>
        <h2 style={{color: '#0d5e2a', marginBottom: '20px'}}>{t('welcome')}</h2>
        <p style={{fontSize: '1.1rem', marginBottom: '30px', lineHeight: '1.6'}}>
          {t('welcomeMessage')}
        </p>
        
        <div style={{display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap'}}>
          <button className="btn btn-primary" onClick={() => navigate(appendUTM('/register'))}>
            {t('registerStudent')}
          </button>
        </div>

        <div style={{marginTop: '50px', textAlign: 'left'}}>
          <h3 style={{color: '#1a6b35', marginBottom: '15px'}}>{t('ourPrograms')}</h3>
          <ul style={{lineHeight: '2'}}>
            <li>{t('quranMemorization')}</li>
            <li>{t('islamicStudies')}</li>
            <li>{t('arabicLanguage')}</li>
            <li>{t('tajweedClasses')}</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
